import useSWR from 'swr'
import { useAccount } from '@/contexts/AccountContext'

export interface UserMe {
  id: string
  email: string
  name?: string | null
}

interface MeQueryResult {
  me: UserMe | null
}

const ME_QUERY = `query {
  me {
    id
    email
    name
  }
}`

export function useMe() {
  const result = useSWR<MeQueryResult, any>([ME_QUERY, {}]);

  return {
    ...result,
    me: result.data?.me ?? null,
  }
}
